import { useHistory } from 'react-router-dom';
import {
  Card,
  CardActionArea,
  CardContent,
  CardMedia,
  Dialog,
  DialogActions,
  DialogTitle,
  IconButton,
  Typography,
} from '@mui/material';
import { makeStyles } from '@mui/styles';
import { X } from 'ts-react-feather-icons';

type Props = {
  showModal: boolean;
  setShowModal: (value: boolean) => void;
  onExitClick: () => void;
  onActionClick: () => void;
};

const useStyles = makeStyles((theme) => ({
  root: { textAlign: 'center' },
  actions: {
    display: 'flex',
    justifyContent: 'center',
    margin: 'auto',
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
  logo: {
    height: '60px',
    width: '60px',
    margin: 'auto',
    marginTop: '75px',
  },
  title: {
    fontWeight: 600,
  },
  description: {
    width: '50vw',
    margin: 'auto',
    marginBottom: '30px',
    fontWeight: 600,
  },
  buttonText: {
    textAlign: 'center',
    display: 'flex',
    fontWeight: 600,
  },
  questionnaireButton: {
    display: 'flex',
    flexWrap: 'wrap',
    width: '250px',
    paddingBottom: '50px',
    '&:hover': {
      backgroundColor: '#F1FCFF',
    },
  },
  scheduleButton: {
    display: 'flex',
    flexWrap: 'wrap',
    width: '250px',
    paddingBottom: '30px',
    backgroundColor: '#FFFFFF',
    '&:hover': {
      backgroundColor: '#F1FCFF',
    },
  },
  media: {
    objectFit: 'scale-down',
  },
  card: {
    margin: '25px',
    minHeight: '280px',
  },
}));

const EstateModuleModal = ({ showModal, setShowModal, onExitClick, onActionClick }: Props) => {
  const classes = useStyles();
  const history = useHistory();
  onActionClick = () => history.push(`intake-form`);

  return (
    <Dialog
      fullWidth={true}
      maxWidth="lg"
      open={showModal}
      transitionDuration={{ enter: 300, exit: 0 }}
      onClose={() => {
        setShowModal(false);
      }}
      className={classes.root}
    >
      <img src="/trustate-logo.svg" className={classes.logo} alt="trustate-logo" />
      <DialogTitle>
        <Typography className={classes.title} variant="h4">
          Complete the Estate Module
        </Typography>
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onExitClick}
          size="large"
        >
          <X />
        </IconButton>
      </DialogTitle>
      <Typography className={classes.description}>
        To get started, we need to gather some information about you and the estate. You can do this
        on your own, or with some help.
      </Typography>
      <DialogActions className={classes.actions}>
        <Card className={classes.card}>
          <CardActionArea className={classes.questionnaireButton} onClick={onActionClick}>
            <CardMedia image="/questionnaire.png" className={classes.media} component="img" />
            <CardContent>
              <Typography className={classes.buttonText}>
                Complete our guided questionnaire on your own.
              </Typography>
            </CardContent>
          </CardActionArea>
        </Card>
        <Card className={classes.card}>
          <CardActionArea className={classes.scheduleButton}>
            <CardMedia image="/schedule-call.png" className={classes.media} component="img" />
            <CardContent>
              <Typography className={classes.buttonText}>
                Schedule a call with your Concierge. They'll take the information over the phone.
              </Typography>
            </CardContent>
          </CardActionArea>
        </Card>
      </DialogActions>
    </Dialog>
  );
};
export default EstateModuleModal;
